import { json, type LoaderFunctionArgs } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { GeneralErrorBoundary } from '#app/components/error-boundary.tsx'
import { ErrorList } from '#app/components/forms.tsx'
import RaceCard from '#app/components/Running/RaceCard.js'
import { getRacesFromContentful } from '#app/utils/contentful.server.js'
import { cn, useDelayedIsPending } from '#app/utils/misc.tsx'

export async function loader({}: LoaderFunctionArgs) {
	//const races = [{ id: '1', name: 'race 1' }]
	const races = await getRacesFromContentful()
	// console.log('RACES:\n', races)
	if (!races) {
		return json({ status: 'error', error: 'No races' } as const, {
			status: 400,
		})
	}
	return json({ status: 'idle', races: races } as const)
}

export default function RunningRoute() {
	const data = useLoaderData<typeof loader>()
	const isPending = useDelayedIsPending({
		formMethod: 'GET',
		formAction: '/users',
	})

	if (data.status === 'error') {
		console.error(data.error)
	}

	return (
		<div className="container mb-48 mt-36 flex flex-col items-center justify-center gap-6">
			<h1 className="text-h1">Running</h1>
			<main>
				<p>
					I began walking regularly to improve my health in around 2015. As a
					heavy guy, this wasn't an easy road to start but I stuck with it and
					eventually I was walking about 3 miles on Saturdays. The problem I had
					though was that it took forever, an hour to walk on a Saturday
					morning? Preposterous!
				</p>
				{data.status === 'idle' ? (
					data.races.raceCollection.items.length ? (
						<ul
							className={cn(
								'flex w-full flex-wrap items-start justify-center gap-4 delay-200',
								{ 'opacity-50': isPending },
							)}
						>
							{data.races.raceCollection.items.map((raceEntry) => {
								return <RaceCard key={raceEntry.sys.id} race={raceEntry} />
							})}
						</ul>
					) : (
						<p>No races found</p>
					)
				) : data.status === 'error' ? (
					<ErrorList errors={['There was an error parsing the results']} />
				) : null}
			</main>
		</div>
	)
}

export function ErrorBoundary() {
	return <GeneralErrorBoundary />
}
